<div #omniSearchRoot class="omni-search-container">
  <div class="omni-search-bar">
    @if (activeProvider()) {
      <div class="provider-chip">
        {{ activeProvider()?.label }}
        @if(!singleProvider()) {
          <button class="chip-clear" (click)="clearProvider()">×</button>
        }
      </div>
    }

    <input
      #searchInput
      type="text"
      pInputText
      [ngModel]="query()"
      (ngModelChange)="query.set($event); onInputChange()"
      (focus)="onFocus()"
      (blur)="onInputBlur($event)"
      placeholder="Search..."
      class="search-input"
    />

    <button
      type="button"
      class="search-btn"
      (click)="onSearch()"
      [disabled]="!activeProvider() || loading() || query() === ''"
      [class.disabled]="!activeProvider() || loading()"
    >
      @if (!loading()) {
        <i class="pi pi-search"></i>
      } @else {
        <i class="pi pi-spin pi-spinner"></i>
      }
    </button>

  </div>


  <!-- Inline suggestion dropdown -->
  @if (showSuggestions() && suggestedProviders().length > 0) {
    <div class="omni-dropdown">
      @for (p of suggestedProviders(); let i = $index; track p.id) {
        <div
          class="dropdown-item"
          role="button"
          tabindex="0"
          [class.focused]="highlightedIndex() === i"
          (click)="selectProvider(p, true)"
          (keydown.enter)="selectProvider(p, true)"
          (keydown.space)="$event.preventDefault(); selectProvider(p, true)"
        >
          <span class="shortcut">{{ p.shortcut }}</span>
          <span class="label">{{ p.label }}</span>
        </div>
      }
    </div>
  }


  <!-- Provider palette (on click without typing) -->
  @if (showPalette() && !showSuggestions()) {
    <div #paletteContainer class="omni-palette">
      <bds-scroll-region maxHeight="60vh" ariaLabel="Search providers">
        <div class="palette-header">Search in:</div>
        @for (group of groupedProviders(); let gIndex = $index; track group) {
          <div class="palette-group">
            <div class="palette-title">{{ group.subApp }}</div>
            @for (p of group.providers; let pIndex = $index; track p) {
              <div
                class="palette-item"
                role="button"
                tabindex="0"
                [class.focused]="highlightedIndex() === _absoluteIndex(gIndex, pIndex)"
                (click)="selectProvider(p)"
                (keydown.enter)="selectProvider(p)"
                (keydown.space)="$event.preventDefault(); selectProvider(p)"
              >
                <span>{{ p.label }} - {{ p.shortcut }}</span>
                @if (p.description) {
                  <i class="pi pi-question-circle" pTooltip="{{ p.description }}"></i>
                }
              </div>
            }
          </div>
        }
      </bds-scroll-region>
    </div>
  }

  @if (showRecentSearches()) {
    <div class="omni-palette omni-palette-with-sticky-header omni-history-palette">
      <div class="palette-header palette-header-sticky">
        <span class="palette-header-title">Recent searches</span>
      </div>
      <bds-scroll-region
        styleClass="omni-palette-scroll-body palette-group"
        maxHeight="calc(17.5rem - 2.75rem)"
        ariaLabel="Recent searches"
      >
        @for (entry of recentHistoryEntries(); track entry.id) {
          <div class="omni-history-row">
            <button
              type="button"
              class="omni-history-query"
              [attr.aria-label]="
                'Show results for ' + entry.query + ', ' + historyResultCountLabel(entry)
              "
              (click)="applyHistoryEntry(entry)"
            >
              <span class="omni-history-query-text">{{ entry.query }}</span>
              <span class="omni-history-count">({{ historyResultCountLabel(entry) }})</span>
            </button>
            <button
              type="button"
              class="chip-clear omni-history-remove"
              aria-label="Remove from history"
              (click)="removeHistoryEntry(entry, $event)"
            >
              ×
            </button>
          </div>
        }
      </bds-scroll-region>
    </div>
  }

  <!-- Search results -->
  @if (activeProvider() && results() && results()!.length > 0) {
    <div class="omni-palette omni-palette-with-sticky-header">
      <div class="palette-header palette-header-sticky">
        <span class="palette-header-title">{{ activeProvider()?.label }}</span>
        <span class="palette-header-count">({{ omniResultsCountLabel(results()!.length) }})</span>
      </div>
      <bds-scroll-region
        styleClass="omni-palette-scroll-body palette-group"
        maxHeight="calc(60vh - 2.75rem)"
        ariaLabel="Search results"
      >
        @for (r of results(); track $index) {
          @if (activeComponent()) {
            <div
              class="result-item"
              role="button"
              tabindex="0"
              (click)="clearSearch()"
              (keydown.enter)="clearSearch()"
              (keydown.space)="$event.preventDefault(); clearSearch()"
            >
              <ng-container
                *ngComponentOutlet="
                  activeComponent();
                  inputs: { data: r.data, providerId: activeProvider()?.id }
                "
              ></ng-container>
            </div>
          }
        }
      </bds-scroll-region>
    </div>
  } @else if (
    activeProvider() && results() && results()!.length === 0 && !showRecentSearches()
  ) {
    <div class="omni-palette omni-palette-with-sticky-header">
      <div class="palette-header palette-header-sticky">
        <span class="palette-header-title">{{ activeProvider()?.label }}</span>
        <span class="palette-header-count">({{ omniResultsCountLabel(0) }})</span>
      </div>
      <bds-scroll-region
        styleClass="omni-palette-scroll-body palette-group"
        maxHeight="calc(60vh - 2.75rem)"
        ariaLabel="Search results"
      >
        <div class="no-results text-center">No results found</div>
      </bds-scroll-region>
    </div>
  }
</div>
